<template>
  <div class="draw_scroll" ref="scrollWrap">
    <div class="draw_list"
         v-infinite-scroll="loadMore"
         infinite-scroll-immediate="false"
         v-if="!isLogin||draw_list.length==0">
      <div class="draw_list_item"
           v-for="(item,index) in sampleSysList"
           :key="index">
        <div class="text">
          <div class="title flex jb">
            <div class="info flex ac">
              <img class="avatar" src="../img/dall_log1.png" alt="">
              <div>
                <p style="margin-bottom: 3px">
                  <span class="topic">DALL-E3</span>
                  <span class="tag">AI机器人</span>
                  <span class="mgTitp" v-if="item.img_type=='img_video'">魔法</span>
                </p>
                <p>
                  <span class="time">{{ item.add_time }}</span>
                </p>
              </div>
            </div>
            <div class="flex ac">
              <p class="delete flex ac"
                 @click="sampleDeleteDraw(item,index)">
                <i class="el-icon-delete"></i><span>删除</span>
              </p>
              <p class="delete flex ac"
                 @click="down_draw_list('sample')">
                <i class="el-icon-download"></i><span>下载</span>
              </p>
            </div>
          </div>
          <div class="desc">
            <p class="zh">{{ item.prompt }}</p>
            <p class="en">{{ item.prompt_en }}</p>
          </div>
<!--          <template v-if="item.progress < 100">-->
<!--            <div class="detail_loading msg-item-content">-->
<!--              <circleloading></circleloading>-->
<!--              <div class="loading_text">DALL-E3 绘图需要极大的计算量，请耐心等待...</div>-->
<!--            </div>-->
<!--            <div class="creating_progress"-->
<!--                 v-if="item.progress > 0">-->
<!--              <div class="progress_bar">-->
<!--                <div class="progress_line"-->
<!--                     :style="{'width':item.progress+'%'}"></div>-->
<!--              </div>-->
<!--              <div class="progress_percent">{{ item.progress }}%</div>-->
<!--            </div>-->
<!--          </template>-->
          <div>
            <div class="big_img">
              <div class="msg_img_wrap">
                <el-image :src="item.oss_small_img"
                          :preview-src-list="[item.raw_img_url]">
                </el-image>
                <!-- 高级图片编辑 -->
               <AdvancedPictureEdit :item="item" :soft_type="'mj'" :btn_opt_type="'btn_dalle3_create'" @editSuccess="editSuccess"></AdvancedPictureEdit>
                <div @click.stop="ImageJump(item.raw_img_url,item.s_w,item.s_h)" class="look_img">查看原图</div>

              </div>
            </div>
            <mgcPop :item="item" :is-first="index" :is-samp="true" :is-d3="true"></mgcPop>
          </div>
        </div>
      </div>
    </div>

    <div class="draw_list"
         v-infinite-scroll="loadMore"
         :infinite-scroll-disabled="noMore || loading">
      <div class="draw_list_item"
           v-for="(item,index) in draw_list"
           :key="index">
        <div class="text">

          <div class="title flex jb">
            <div class="info flex ac">
              <img class="avatar" src="../img/dall_log1.png" alt="">
              <div>
                <p style="margin-bottom: 3px">
                  <span class="topic">DALL-E3</span>
                  <span class="tag" v-if="!item.model_version">AI-Bot</span>
                  <span class="tag" v-else-if="item.model_version">高级编辑 - {{ item.model_version }}</span>
                </p>
                <p>
                  <span class="time">{{ item.add_time }}</span>
                </p>
              </div>
            </div>
            <div class="flex ac">
              <el-popover placement="bottom-end" width="200" trigger="click" ref="morePopover">
                <div class="more_list">
                  <p class="operate_item flex ac"
                     @click="share_draw_item(item, index)"><img class="share"
                                                                src="../../views/img/icon_img48.png"/><span>分享</span>
                  </p>
                  <template
                      v-if="(item.img_type=='img_c'||item.img_type=='img_v'||item.img_type.indexOf('zoom')>0||item.img_type.indexOf('_pan_')>0||item.img_type.indexOf('_variation')>0) && item.status==2">
                    <p class="operate_item flex ac"
                       v-if="item.is_public==0"
                       @click="pulic_draw_item(item, index)"><img
                        src="../../views/img/prasie.png"/><span>推荐到广场</span></p>
                    <p class="operate_item flex ac"
                       v-else
                       style="color: #f0b132;"
                       @click="pulic_draw_item(item, index)"><img
                        src="../../views/img/prasie-fill.png"/><span>已推荐到广场</span></p>
                  </template>
                  <p class="operate_item flex ac"
                     @click="delete_draw_list(item.draw_id, index)"><img
                      src="../../views/img/delete.svg"/><span>删除</span>
                  </p>
                  <p class="operate_item flex ac"
                     v-if="item.img_type=='img_video'&&item.status=='2'"
                     @click="down_draw_list('video',item,index)">
                    <i class="el-icon-download" style="font-size: 20px"></i><span>下载</span>
                  </p>
                  <p class="operate_item flex ac"
                     v-if="item.img_type=='img_edit'&&item.status=='2'"
                     @click="down_draw_list('video',item,index,'right')">
                    <i class="el-icon-download" style="font-size: 20px"></i><span>下载</span>
                  </p>
                  <p class="operate_item flex ac"
                     v-if="item.img_type!='img_video'&&item.img_type!='img_edit'&&item.status=='2'"
                     @click="down_draw_list('draw',item,index)">
                    <i class="el-icon-download" style="font-size: 20px"></i><span>下载</span>
                  </p>
                </div>
                <div class="more_btn" flex-center slot="reference"><i class="el-icon-more"></i></div>
              </el-popover>
            </div>
          </div>
          <div class="desc">
            <p class="zh">{{ item.prompt }}</p>
            <p class="en">{{ item.prompt_en }}</p>
          </div>
          <div class="create_error" v-loading="item.regenerateload"
            v-if="(item.status == 3)&&(item.retry_num<3 && item.is_retry==0)">
            <img class="error_icon"
                 src="../../views/img/image_error.png"
                 alt="">
            <div class="error_text">很遗憾，绘画失败 !</div>
            <div class="error_new_btn" @click="error_new_fn(item.draw_id,index)">
              点此重新生成<br /><span class="err_succ_text">（成功率90%以上）</span> 
            </div>
            <div class="err_new_tip" v-if="item.show_error">
              失败原因： <span style="color:red;">{{ item.show_error }}</span>
            </div>
            <div class="err_new_tip" v-else>
            涉政、涉黄等请勿提交，会封号。其他问题，请联系<span class="err_tokf" @click="toKf">在线客服</span>
            </div>
          </div>

          <div class="create_error create_error_old" v-else-if="(item.status == 3)&&(item.retry_num>=3 || item.is_retry!=0)">
                <!-- 绘画 失败 -->
                <img class="error_icon" src="../../views/img/image_error.png" alt="">
                <div class="error_text">很遗憾，绘画失败 !</div>
                <div class="error_btn" @click="showDefeatPopup">查看失败原因</div>
            <div class="err_new_tip" v-if="item.show_error">
              失败原因： <span style="color:red;">{{ item.show_error }}</span>
            </div>
                <div class="err_new_tip" v-else>
            涉政、涉黄等请勿提交，会封号。其他问题，请联系<span class="err_tokf" @click="toKf">在线客服</span>
            </div>
              </div>
          <template v-else-if="item.status < 2">
            <div class="detail_loading msg-item-content">
              <circleloading></circleloading>
              <div class="loading_text"
                   v-if="item.progress <= 0">DALL-E3 正在全力出图中，请稍等...
              </div>
            </div>
            <div class="creating_progress"
                 v-if="item.progress > 0">
              <div class="progress_bar">
                <div class="progress_line"
                     :style="{'width':item.progress+'%'}"></div>
              </div>
              <div class="progress_percent">{{ item.progress }}%</div>
            </div>
          </template>
          <div v-else>
            <div class="big_img"
                 v-if="item.img_url">
              <!-- <el-image style="max-width: 400px"  :src="item.img_url+'?width=700&height=700'" :preview-src-list="[item.img_url+'?width=700&height=700']"></el-image> -->
              <div class="msg_img_wrap mg_video_box" v-if="item.img_type=='img_video'">
                <div class="mg_video_item">
                  <video class="videoBox" :poster="item.raw_img_url"
                         controlslist="nodownload" controls>
                    <source :src="item.img_url" type="video/mp4">
                  </video>
                  <!-- <button id="playButton" class="play-btn">▶</button> -->
                </div>
              </div>
              <div class="msg_img_wrap" v-else>
<!--                <div style="width: auto;display: inline-block;background-color:#fff;">-->
                  <el-image style="display:block;"
                            @click.prevent="clickImage(item.raw_img_url)"
                            :src="item.img_url"
                            :preview-src-list="[item.raw_img_url]">
                  </el-image>
<!--                </div>-->
                <div @click.stop="ImageJump(item.raw_img_url,item.s_w,item.s_h)" class="look_img">查看原图</div>
                <!-- 高级图片编辑 -->
               <AdvancedPictureEdit :item="item" :soft_type="'dall'" :btn_opt_type="'btn_dalle3_create'" @editSuccess="editSuccess"></AdvancedPictureEdit>
              </div>
            </div>
            <div class="creating_progress"
                 v-if="item.progress > 0 && item.status < 2&&!item.model_version">
              <div class="progress_bar">
                <div class="progress_line"
                     :style="{'width':item.progress+'%'}"></div>
              </div>
              <div class="progress_percent">{{ item.progress }}%</div>
            </div>
          </div>
          <mgcPop :item="item" :is-first="index" @magData="mgcPFn" :btn_opt_type="'btn_dalle3_create'" :is-d3="true" v-if="item.img_type!='img_video'&&item.status==2&&!item.model_version"></mgcPop>
        </div>
      </div>
    </div>
    <popup ref="defeatPopup"
           type="center"
           @close="defeatPopClose">
      <div class="defeat_popup">
        <div class="popup_title">失败原因如下</div>
        <div class="popup_content">
          <div class="content_items">
            <div class="item_question">问：为什么DALL-E3绘画出图会比较慢？</div>
            <div class="item_answer">
              答：因为DALL-E3与其他绘画软件不同，一次性生成四张高清图片，通常仅需约5分钟完成，算下来速度相当快！
            </div>
          </div>
          <div class="content_items">
            <div class="item_question">问：为什么绘画会提示失败？</div>
            <div class="item_answer">
              答：因为DALL-E3绘画全部为Ai原创，可能会出现违规低俗内容，这些图片会被系统自动过滤删除，与您无关！
            </div>
          </div>
        </div>
        <button class="close_btn"
                @click="defeatPopClose">好的，我知道了
        </button>
      </div>
    </popup>
    <!-- 推荐到广场 -->
    <Recommend v-if="current_draw&&show_recommend_popup"
               :draw_item="current_draw"
               @close="recommendCallBack"
               ref="recommend"></Recommend>
    <!-- 分享 -->
    <ShareDraw v-if="current_draw&&show_sharedraw_popup"
               :draw_item="current_draw"
               @close="show_sharedraw_popup=false"
               ref="ShareDraw"></ShareDraw>
    <!--采集-->
    <drawCateEdit ref="drawCateEdit"
                  @close="caiJiOk"></drawCateEdit>

    <!-- 反馈弹窗 -->
    <FeedBack v-if="current_draw&&show_feedback_popup"
              :draw_item="current_draw"
              @close="show_feedback_popup=false"
              ref="feedback"></FeedBack>
    <popup ref="viewPopup"
           type="center"
           @close="popClose">
      <img class="view_img"
           :src="view_img_url"
           style="width:100% !important;height:100% !important;">
      <!-- <el-image style="display:block;max-width: 400px;" :src="view_img_url" :preview-src-list="[view_img_url]"></el-image> -->
    </popup>
    <canvas ref="localCanvas"
            style="display: none;"
            useCORS="true"
            allowTaint="true"></canvas>
    <el-image ref="previewImg" style="display: none;" :src="view_img_url" :preview-src-list="[view_img_url]"></el-image>
    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
  </div>
</template>
<script type="text/ecmascript-6">
import popup from "COMPONENTS/Popup.vue"
import circleloading from "COMPONENTS/CircleLoading.vue"
import FeedBack from '@/components/FeedBack.vue'
import Recommend from '@/components/Recommend.vue'
import ShareDraw from '@/components/ShareDraw.vue'
import drawCateEdit from '@/components/DrawCateEdit'
import TipsWords from '@/components/TipsWords'
import mgcPop from "COMPONENTS/mgcPop.vue"
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import AdvancedPictureEdit from '@/components/AdvancedPictureEdit.vue'
import utils from "@/utils";

export default {
  components: {mgcPop,popup, circleloading, FeedBack, Recommend, ShareDraw, drawCateEdit, TipsWords,faceVerifyPopup,AdvancedPictureEdit},
  props: ['sampleList'],
  data() {
    return {
      //显示用户反馈
      show_feedback_popup: false,
      //显示推荐到广场
      show_recommend_popup: false,
      //显示分享弹窗
      show_sharedraw_popup: false,
      current_draw: null,//当前选中的记录
      draw_list: [],
      noMore: false, // 是否还有数据
      loading: false, // 正在请求数据
      max_mj_id: 0, // 最小的ID
      checkIds: [], // 生成中的需要检测的ID
      timer: null,
      sampleSysList: [], // 系统样例
      sampleUserList: [], // 用户样例
      sampleTimer: null,
      view_img_url: "",
      page: 1,
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    }
  },
  created() {
    console.log("fetchDataList create")
    this.sampleUserList = JSON.parse(localStorage.getItem('sampleUserList') || "[]")
    // if (this.sampleUserList.length > 0) {
    //   this.sampleSysList = this.sampleUserList
    //   this.choose_tips_item()
    // } else {
    //   this.sampleSysList = this.sampleList
    // }
    this.fetchDataList()
    this.fettchSampleList()
  },
  methods: {
    // 高级图片编辑成功
    editSuccess(data){
      this.max_mj_id = 0
      this.draw_list.unshift(data)
      this.scrollToTop();
      this.checkIds.push(data.draw_id)
      this.fetchMsg()
    },
    error_new_fn(id,ind){
      //{params:{id}}
      this.draw_list[ind].regenerateload = true
      this.$forceUpdate()
      this.$http.post('/front/aimj/draw/retry/',{id}).then(res=>{
        if(res.status==200){
          this.draw_list[ind].is_retry +=1
          this.draw_list[ind].regenerateload = false
          this.scrollToTop();
          this.$message.success('重新生成创建成功');
          this.draw_list.unshift(res.data)
          this.checkIds.push(res.data.draw_id)
          this.fetchMsg()
        }else{
          this.draw_list[ind].regenerateload = false
          this.$forceUpdate()
          let message = res.message;
                    if (message == "vip_expire") {
                        // VIP 过期了
                        this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
                            confirmButtonText: '开通会员',
                            cancelButtonText: '取消',
                            type: 'warning',
                            customClass:'confirm_box'
                        }).then(() => {
                            this.$router.push('/member')
                        }).catch(() => {

                        });
                        return
                    } else if (message == "no_open_vip") {
                        // 未开通 VIP
                        this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
                            confirmButtonText: '开通会员',
                            cancelButtonText: '取消',
                            type: 'warning',
                            customClass:'confirm_box'
                        }).then(() => {
                            this.$router.push('/member')
                        }).catch(() => {

                        });
                        return
                    } else if (message == "no_gift_score") {
                        // 积分不足
                        this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
                            confirmButtonText: '升级套餐',
                            cancelButtonText: '取消',
                            type: 'warning',
                            customClass:'confirm_box'
                        }).then(() => {
                            this.$router.push('/member')
                        }).catch(() => {

                        });
                        return
                    } else if (message == "upgradevip") {
                        // 队列已满
                        this.$confirm(res.data.msg, '提示', {
                            confirmButtonText: '升级套餐',
                            cancelButtonText: '取消',
                            type: 'warning',
                            customClass:'confirm_box'
                        }).then(() => {
                            this.$router.push('/member')
                        }).catch(() => {

                        });
                        return
                    }else if (message == "no_face_verify") {
                      // 实名认证
                      this.$refs.faceVerifyPopup.show()
                      return
                    }else if(message == 'retry_num_max'){
                      message = '已超出最大重试次数'
                    }
                    if (message.indexOf("您提问的内容包含违禁词") > -1) {
                        message = "内容可能违反国家政策，请重新输入";
                    }
                    this.$confirm(message, '提示', {
                        type: 'warning',
                        customClass:'confirm_box'
                    }).then(() => {
                    })
          // if(res.message=='upgradevip'){
          //   this.$message.error(res.data.msg)
          // }
          // this.$message.error(res.data.msg)
        }
      }).catch(err=>{
        this.draw_list[ind].regenerateload = false
        this.$forceUpdate()
        let message = res.message;
                    if (message == "vip_expire") {
                        // VIP 过期了
                        this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
                            confirmButtonText: '开通会员',
                            cancelButtonText: '取消',
                            type: 'warning',
                            customClass:'confirm_box'
                        }).then(() => {
                            this.$router.push('/member')
                        }).catch(() => {

                        });
                        return
                    } else if (message == "no_open_vip") {
                        // 未开通 VIP
                        this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
                            confirmButtonText: '开通会员',
                            cancelButtonText: '取消',
                            type: 'warning',
                            customClass:'confirm_box'
                        }).then(() => {
                            this.$router.push('/member')
                        }).catch(() => {

                        });
                        return
                    } else if (message == "no_gift_score") {
                        // 积分不足
                        this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
                            confirmButtonText: '升级套餐',
                            cancelButtonText: '取消',
                            type: 'warning',
                            customClass:'confirm_box'
                        }).then(() => {
                            this.$router.push('/member')
                        }).catch(() => {

                        });
                        return
                    } else if (message == "upgradevip") {
                        // 队列已满
                        this.$confirm(res.data.msg, '提示', {
                            confirmButtonText: '升级套餐',
                            cancelButtonText: '取消',
                            type: 'warning',
                            customClass:'confirm_box'
                        }).then(() => {
                            this.$router.push('/member')
                        }).catch(() => {

                        });
                        return
                    }else if (message == "no_face_verify") {
                      // 实名认证
                      this.$refs.faceVerifyPopup.show()
                      return
                    }else if(message == 'retry_num_max'){
                      message = '已超出最大重试次数'
                    }
                    if (message.indexOf("您提问的内容包含违禁词") > -1) {
                        message = "内容可能违反国家政策，请重新输入";
                    }
                    this.$confirm(message, '提示', {
                        type: 'warning',
                        customClass:'confirm_box'
                    }).then(() => {
                    })
      })
    },
    toKf(){
      utils.tokf()
      // window.open('/linkus')
    },
    mgcPFn(data){
      this.submitQuestion(data)
    },
    fettchSampleList() {
      // 获取样例数据
      let bd_vid = this.getCache("bd_vid") || ""
      let qhclickid = this.getCache("qhclickid") || ""
      let sourceid = this.getCache("sourceid") || ""

      let ad_account_id = this.getCache("ad_account_id") || 0


      this.$http.get('/front/aidl/draw/sample/', {
        params: {
          max_mj_id: this.max_mj_id,
          page: this.page,
          bd_vid:bd_vid,
          qhclickid:qhclickid,
          sourceid:sourceid,
          ad_account_id:ad_account_id
        }
      }).then((res) => {
        let _list = res.data.item_list

        this.noMore = false
        this.loading = false
        this.sampleSelectList = _list.slice(_list.length - 20, _list.length)
        // console.log(this.sampleUserList)
        if (this.sampleUserList.length > 0) {
          this.sampleSysList = this.sampleUserList
        } else {
          this.sampleSysList = this.sampleSysList.concat(_list)
        }
        console.log(this.sampleSysList)
      })
    },
    sampleDrawImg() {
      // 样例图片 U V 处理
      this.checkLogin()
    },
    sampleDeleteDraw(item, index) {
      // 样例图片 删除
      if (!this.checkLogin()) {
        return
      }
      this.$confirm('确定删除该创作记录吗，删除后不可恢复', '提示', {
        type: 'warning',
        customClass: 'confirm_box'
      }).then(() => {
        this.sampleSysList.splice(index, 1)
        let j = -1
        for (let i = 0; i < this.sampleUserList.length; i++) {
          console.log(this.sampleUserList[i].draw_id, item.draw_id)
          if (this.sampleUserList[i].draw_id == item.draw_id) {
            j = i
          }
        }
        if (j > -1) {
          this.sampleUserList.splice(j, 1)
          localStorage.setItem("sampleUserList", JSON.stringify(this.sampleUserList))
        }
      }).catch(() => {
      })
    },
    //选择提示词
    choose_tips_item() {
      // 样例 选中
      this.scrollToTop()
      if (this.sampleTimer !== null) {
        return
      }
      this.sampleTimer = setInterval(() => {
        let createNum = 0; // 需要生成个数
        this.sampleSysList.forEach(e => {
          if (e.progress < 100) {
            createNum += 1
            let num = parseInt(Math.random() * 10);
            if (e.progress + num > 100) {
              e.progress = 100
              this.sampleUserList.forEach(m => {
                if (e.draw_id == e.draw_id) {
                  e.progress = 100
                  localStorage.setItem("sampleUserList", JSON.stringify(this.sampleUserList))
                }
              })
              this.scrollToTop()
            } else {
              e.progress += num
            }
          }
        })
        if (createNum == 0) {
          clearInterval(this.sampleTimer)
          this.sampleTimer = null
          this.scrollToTop()
        }
      }, 500)
    },
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)
          this.$store.commit('setShowLogin', true)
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }
    },

    loadMore() {
      // 加载更多数据
      this.noMore = true
      this.loading = true
      if (this.isLogin) {
        // 登录请求样例
        this.fetchDataList()
      } else {
        // 未登录请求样例
        // this.pageType = false
        if (!(this.sampleSysList.length % 10 === 0)) {
          this.$message.warning('样例已全部加载')
          return
        }
        if (this.page >= 3) {
          console.log('已经加载完成')
          this.$message.warning('样例已全部加载')
          return
        }
        this.page = this.page + 1
        this.fettchSampleList()
      }
    },
    fetchDataList() {
      // 对话内容
      this.loading = true
      this.$http.get('/front/aidl/user/draw/', {params: {max_mj_id: this.max_mj_id}}).then((res) => {
        if (res.status == 200) {
          if (res.data.item_list.length > 0) {
            if (this.max_mj_id == 0) {
              res.data.item_list.forEach(e => {

                if (e.status <= 1 || (e.status == 2 && e.local_img_url == "")) {
                  this.checkIds.push(e.draw_id)
                }
              })
              this.fetchMsg()
            }
            this.max_mj_id = res.data.item_list[res.data.item_list.length - 1].draw_id
            res.data.item_list.forEach(item=>{
              if(!item.regenerateload){
                item.regenerateload = false
              }
            })
            this.draw_list = this.draw_list.concat(res.data.item_list)
            // this.draw_list[0].status = 3
            // this.draw_list[0].show_error = 1123123
          } else {
            this.noMore = true
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    submitQuestion(data, parent_msg_code, i) {
      if (this.sending) {
        this.$message({
          message: '正在任务，不要重复提交，请稍后！',
          type: 'waring'
        });
        return
      }
      this.sending = true;
      // 提交问题
      data.source = "pc";
      this.$http.post('/front/aidl/draw/', data).then((res) => {
        if (res.status == 200) {
          this.inputVal = "";
          if(data.img_type!='img_video'){
            this.draw_list.splice(0, 1, res.data.draw)
            this.scrollToTop();
            this.checkIds.push(res.data.draw.draw_id)
          }else{
            this.draw_list.unshift(...res.data.draw);
            this.scrollToTop();
            res.data.draw.forEach(mg_id=>{
              this.checkIds.push(mg_id.draw_id)
            })
          }
          // this.draw_list.unshift(res.data.draw);
          // this.scrollToTop();
          // // 发送消息
          // this.checkIds.push(res.data.draw.draw_id)

          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });

          this.fetchMsg();
        } else {

          let message = res.message;
          if (message == "vip_expire") {
            // VIP 过期了
            this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/mjmember')
            }).catch(() => {

            });
            return
          } else if (message == "no_open_vip") {
            // 未开通 VIP
            this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/mjmember')
            }).catch(() => {

            });
            return
          } else if (message == "no_gift_score") {
            // 积分不足
            this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/mjmember')
            }).catch(() => {

            });
            return
          } else if (message == "upgradevip") {
            // 队列已满
            this.$confirm(res.data.msg, '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/mjmember')
            }).catch(() => {

            });
            return
          }
          if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
          }
          this.$confirm(message, '提示', {
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
          })
        }
      }).finally(() => {
        this.sending = false;
      })
    },
    fetchMsg() {
      if (this.checkIds.length == 0) {
        return
      }
      if (this.timer) {
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        this.$http.post('/front/aimj/draw/check/', {ids: this.checkIds}).then((res) => {
          if (res.status == 200) {
            let item_list = res.data.item_list;
            let draw_id = 0;
            item_list.forEach(e => {
              draw_id = e.draw_id
              let item = this.draw_list.filter((obj) => obj.draw_id == draw_id)[0];

              item.status = e.status
              item.progress = e.progress;
              item.s_w = e.s_w
              item.s_h = e.s_h
              item.pic_num = e.pic_num
              item.retry_num = e.retry_num
              item.is_retry = e.is_retry
              item.show_error = e.show_error

              if (e.status > 2) {
                // 删除生成成功或失败的
                console.log("删除生成成功或失败的", e)
                if (e.show_error) {
                  this.$message.error(e.show_error)
                }
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
              }
              if (e.status == 2 && e.local_img_url != "") {
                // 生成成功 并下载本地
                console.log("生成成功 并下载本地", e)
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
                item.img_url = e.local_img_url
                item.raw_img_url = e.raw_img_url
                this.scrollToTop();
                // 创作成功检测是否弹出挽留弹窗
                utils.checkContinuePop(this.$store.state.userInfo)
              }
              if (e.status == 3) {
                // 绘画失败
              }
            })
            this.$forceUpdate()
          }
          if (this.checkIds.length == 0) {
            clearInterval(this.timer);
          }
        }).catch((res) => {
          console.log(res)
          clearInterval(this.timer);
        })
      }, 3000)
    },
    imgRedraw(item) {
      // 重新绘画
      if (item.status != 2) {
        this.$message({
          message: '任务还未完成，不能操作！',
          type: 'waring'
        });
        return
      }
      let data = {
        parent_draw_id: item.draw_id,
        img_type: "img_redraw",
        img_index: 1
      }
      this.submitQuestion(data, [], 1);
    },
    drawImgUV(type, i, item, status) {
      // 对图片进行 U V 操作
      if (item.status != 2) {
        this.$message({
          message: '任务还未完成，不能操作！',
          type: 'waring'
        });
        return
      }
      if (status != 0) return
      item[type + '_code'][i] = 2;
      let data = {
        parent_draw_id: item.draw_id,
        img_type: "img_" + type,
        img_index: i + 1
      }
      this.submitQuestion(data, item[type + '_code'], i);
    },
    drawImgZoom(type, item) {
      // 对图片进行 zoom 操作
      if (item.status != 2) {
        this.$message({
          message: '任务还未完成，不能操作！',
          type: 'waring'
        });
        return
      }
      let data = {
        parent_draw_id: item.draw_id,
        img_type: "img_" + type,
        img_index: 1
      }
      this.submitQuestion(data, [], 0);
    },

    viewImg(item, type) {
      let img_url = item.raw_img_url
      const canvas = this.$refs.localCanvas;
      let that = this
      var imgRaw = new Image();
      imgRaw.src = img_url
      imgRaw.setAttribute('crossOrigin', 'anonymous');
      imgRaw.onload = function () {
        var arr = []
        let canvasWidth = imgRaw.width / 2; // Assuming split in half
        let canvasHeight = imgRaw.height / 2; // Adjust as needed
        for (var i = 0; i <= 4; i++) {
          canvas.width = canvasWidth
          canvas.height = canvasHeight

          const ctx = canvas.getContext('2d');
          const x = i % 2 === 0 ? 0 : canvasWidth;
          const y = Math.floor(i / 2) === 0 ? 0 : canvasHeight;

          ctx.drawImage(imgRaw, x, y, canvasWidth, canvasHeight, 0, 0, canvasWidth, canvasHeight);

          const base64 = canvas.toDataURL('image/jpeg');
          arr.push(base64);
        }

        that.view_img_url = arr[type - 1]
        // that.$refs.viewPopup.show();
        that.$refs.previewImg.clickHandler();
        that.$nextTick(() => {
          let wrapper = document.getElementsByClassName(
              "el-image-viewer__actions__inner"
          );
          if (wrapper.length > 0) {
            let downImg = document.createElement("i");
            downImg.setAttribute("class", "el-icon-download");
            wrapper[0].appendChild(downImg);
            downImg.addEventListener("click", () => {
              var a = document.createElement("a"); // 生成一个a元素
              var event = new MouseEvent("click"); // 创建一个单击事件
              a.download = Date.now(); // 设置图片名称
              a.href = that.view_img_url; // 将生成的URL设置为a.href属性
              a.dispatchEvent(event); // 触发a的单击事件
            });
          }
        })
      }
    },
    previewImg(url) {
      this.view_img_url = url;
      this.$refs.viewPopup.show();
    },
    popClose() {
      this.$refs.viewPopup.close();
    },
    scrollToTop() {
      this.$nextTick(() => {
        let scrollWrap = this.$refs.scrollWrap;
        scrollWrap.scrollTop = 0;
      })
    },
    delete_draw_list(id, index) {
      // 删除
      this.$confirm('确定删除该创作记录吗，删除后不可恢复？', '提示', {
        type: 'warning',
        customClass: 'confirm_box'
      }).then(() => {
        this.$http.delete(`/front/aimj/draw/${id}/`).then((res) => {
          this.draw_list.splice(index, 1)
        })
      })

    },
    down_draw_list(type,item,index,position) {
      // 下载
      if(type=='sample'){
        this.$message.warning('当前样例禁止下载，请生成后重试')
      } else if(type=='video'){
        this.$http.get(`/front/aimj/draw/video/${item.draw_id}/`,).then(res => {
          if (res.status == '200') {
            window.location.href = res.data.url
          } else {
            let message = res.message
            utils.createErrTip(message)
          }
        }).catch(err=>{
          let message = err.message;
          utils.createErrTip(message)
        }).finally(() => {
          this.loading = false
        })
      }else{
        console.log('作品下载')
        this.$http.get(`/front/aimj/draw/down/${item.draw_id}/?${position!=undefined?'nano_position='+position:''}`,).then(res => {
          if (res.status == '200') {
            window.location.href = res.data.url
          } else {
            let message = res.message
            utils.createErrTip(message)
          }
        }).catch(err=>{
          let message = err.message;
          utils.createErrTip(message)
        }).finally(() => {
          this.loading = false
        })
      }

    },
    showDefeatPopup() {
      this.$refs.defeatPopup.show();
    },
    defeatPopClose() {
      this.$refs.defeatPopup.close();
    },
    share_draw_item(item, index) {
      this.current_draw = item
      this.show_sharedraw_popup = true;
      this.$refs.morePopover[index].doClose();
    },
    recommendCallBack(draw_id) {
      // 推荐到广场 回调
      this.show_recommend_popup = false;
      if (draw_id) {
        this.draw_list.forEach(e => {
          if (e.draw_id == draw_id) {
            e.is_public = 1
          }
        })
      }
    },
    pulic_draw_item(item, index) {
      // 点击弹出推荐到广场
      if (item.is_public == 0) {
        this.current_draw = item
        this.show_recommend_popup = true;
        this.$refs.morePopover[index].doClose();
      } else {
        item.is_public = 0
        this.$http.patch(`/front/aimj/user/draw/${item.draw_id}/`, {
          'action': 'public',
          data: {'sys_cate_id': 0}
        }).then((res) => {
          this.$message({
            message: '取消推荐成功',
            type: 'success'
          });
        }).finally((res) => {
          this.close()
        })
      }

    },
    fave_draw_item(draw, index) {
      // 采集
      this.$refs.drawCateEdit.show(draw, 1)
      this.$refs.morePopover[index].doClose();
    },
    //点击弹出反馈弹窗
    handle_show_feedback_popup(item) {
      this.current_draw = item
      this.show_feedback_popup = true
    },
    async getJSON() {
      let url = 'https://mjimg.zhanjuzhe.cn/media/202407/19/1721384316144.png';
      try {
        let response = await fetch(url);
        return await response.json();
      } catch (error) {
        console.log('Request Failed', error);
      }
    },
    caiJiOk(item) {
      // 采集回调
      this.draw_list.forEach(e => {
        if (e.draw_id == item.draw_id) {
          e.cate_id = 8
        }
      })
    },
    clickImage(raw_img_url) {
      // 下载图片
      this.$nextTick(() => {
        let wrapper = document.getElementsByClassName(
            "el-image-viewer__actions__inner"
        );
        if (wrapper.length > 0) {
          let downImg = document.createElement("i");
          downImg.setAttribute("class", "el-icon-download");
          wrapper[0].appendChild(downImg);
          downImg.addEventListener("click", () => {
            console.log(raw_img_url)
            var image = new Image();
            // 解决跨域 Canvas 污染问题
            image.setAttribute("crossOrigin", "anonymous");
            image.onload = function () {
              var canvas = document.createElement("canvas");
              canvas.width = image.width;
              canvas.height = image.height;
              var context = canvas.getContext("2d");
              context.drawImage(image, 0, 0, image.width, image.height);
              var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

              var a = document.createElement("a"); // 生成一个a元素
              var event = new MouseEvent("click"); // 创建一个单击事件
              a.download = Date.now(); // 设置图片名称
              a.href = url; // 将生成的URL设置为a.href属性
              a.dispatchEvent(event); // 触发a的单击事件
            };
            image.src = raw_img_url;
            //this.downloadImage(raw_img_url, "aaa")
            //这里写下载图片的方法
            // const content = document.querySelector('.el-image-viewer__img'); // 获取需要保存为图片的 DOM 元素
            // html2canvas(content).then(canvas => {
            //     setTimeout(() => {
            //         // 将 Canvas 转换为图片数据
            //         const imageData = canvas.toDataURL('image/png');
            //         // 创建一个 <a> 元素，并设置 href 属性为图片数据
            //         const a = document.createElement('a');
            //         a.href = imageData;
            //         a.download = Date.now() + '.png'; // 设置下载文件名
            //         a.click(); // 模拟点击下载
            //     }, 500)
            // },);
            // const canvas = this.$refs.localCanvas;
            // var imgRaw = new Image();
            // imgRaw.src = raw_img_url
            // imgRaw.setAttribute('crossOrigin', 'anonymous');
            // imgRaw.onload = function () {
            //     canvas.width = imgRaw.width
            //     canvas.height = imgRaw.height
            //     const ctx = canvas.getContext('2d');
            //     ctx.drawImage(imgRaw, 0, 0);
            //     const imageData = canvas.toDataURL('image/jpeg');
            //     const a = document.createElement('a');
            //     a.href = imageData;
            //     a.download = Date.now() + '.png'; // 设置下载文件名
            //     a.click(); // 模拟点击下载
            // }
          });
        }
      });
    },
    ImageJump(imgurl,s_w,s_h){
      // window.open(imgurl + '?width=' + s_w + '&height=' + s_h, '_blank');
      window.open(imgurl, '_blank');
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.timer = null;
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .error_new_btn{
    color: #56b15b;
    .err_succ_text{
      color: #ccc;
    }
  }

  .err_new_tip{
    color: #ccc;
    margin-top: 20px;
    .err_tokf{
      color: red;
    }
  }
.mgTitp{
  margin-left: 10px;
  display: inline-block;
  padding: 0 7px;
  background: linear-gradient(to right, rgb(99, 231, 82), rgb(98, 238, 247));
  border-radius: 4px;
  font-size: 12px;
  line-height: 20px;
  color: #000;
  margin-right: 10px;
}
.mg_video_box{
  // height: 400px;
  .mg_video_item{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;
    // .videoBox::-webkit-media-controls {
    //   display: none !important;
    // }
    // .videoBox::-moz-media-controls {
    //   display: none !important;
    // }
    // .videoBox::-ms-media-controls {
    //   display: none !important;
    // }
    // .videoBox::-o-media-controls {
    //   display: none !important;
    // }
    .play-btn {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: rgba(19, 18, 18, 0.6);
      color: white;
      font-size: 24px;
      border: none;
      border-radius: 50%;
      // padding: 12px 20px;
      cursor: pointer;
      z-index: 10;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
     video {
      max-width: 100%; /* 限制宽度不超过容器宽度 */
      max-height: 100%; /* 限制高度不超过容器高度 */
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* 可选，阴影效果 */
      border-radius: 8px; /* 可选，圆角效果 */
    }
  }
}
.draw_scroll {
  background-color: #313338;
  height: calc(100% - 15px);
  overflow-y: auto;
  color: #fff;

  &::-webkit-scrollbar {
    margin-left: 5px !important;
    display: block !important;
    width: 6px !important;
  }

  &::-webkit-scrollbar-thumb {
    height: 30px !important;
    background-color: #777 !important;
    border-radius: 10px !important;
  }

  .draw_list {
    overflow: hidden;
    width: 100%;
    position: relative;

    .draw_list_item {
      padding-bottom: 5px;
      background: #403d38;
      border-left: 2px solid #f0b132;
      margin: 10px 0;

      .text {
        padding: 10px;
        overflow: hidden;
        word-break: break-all;
        white-space: normal;
        line-height: 20px;

        .title {
          font-size: 12px;
          margin-bottom: 10px;
          .info {
            margin-bottom: 10px;

            .topic {
              font-size: 14px;
              margin-right: 10px;
            }

            .tag {
              background-color: #5865f280;
              display: inline-block;
              color: #fff;
              font-size: 12px;
              padding: 0 5px;
              border-radius: 4px;
              white-space: nowrap;
            }

            .time {
              color: #707070;
            }

            .avatar {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              margin-right: 7px;
              cursor: pointer;
            }

            .time {
              color: #707070;
              font-size: 12px;
            }
          }

          .more_btn {
            width: 36px;
            height: 24px;
            border-radius: 4px;
            color: #fff;
            font-size: 16px;
            background-color: #1e1f22;
          }

          .delete {
            cursor: pointer;
            margin-left: 8px;
            color: #949ba4;

            img {
              width: 20px;
              height: 20px;
              margin-top: -2px;

              &.share {
                width: 16px;
                height: 16px;
              }
            }
          }
        }

        .desc {
          p {
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            line-clamp: 3;
          }

          .en {
            padding-top: 10px;
            margin-top: 10px;
            color: #999168;
            border-top: 1px solid #555041;
          }
        }
      }

      .big_img {
        margin-top: 10px;

        .el-image {
          width: 100%;
        }
      }

      .options {
        .options_list {
          margin-top: 10px;

          .tips_icon {
            width: 14px;
            height: 14px;
            opacity: 0.5;
          }

          span {
            font-size: 13px;
            width: 58px;
            height: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            background: #4e5058;
            margin-left: 8px;
            border-radius: 3px;
            cursor: pointer;

            img {
              width: 18px;
              height: 18px;
            }

            &:hover {
              background: #6e717c;
            }

            &.span {
              width: 100px;

              img {
                margin-right: 5px;
              }
            }

            &.span2 {
              width: 40px;
            }
          }

          //
          .redraw {
            img {
              height: 20px;
              // margin-top: 5px;
            }

            line-height: 32px;
          }

          .btn {
            // flex-grow: 1;
            // height: 32px;
            // line-height: 32px;
            // color: #18a058;
            // background-color: #dbefe4;
            // border-radius: 2px;
            // font-size: 12px;
            // font-weight: bold;
            // text-align: center;
            // cursor: pointer;
            // width: 0;
            &:not(:last-child) {
              margin-right: 0px;
            }

            &.loading {
              opacity: 0.6;

              svg {
                margin-top: -4px;
                vertical-align: middle;
                margin-right: 4px;
                animation: rotate 2s linear infinite;
              }
            }

            &.redraw2 {
              background-color: #f5f6fb;

              img {
                height: 30px;
              }
            }

            &.disabled {
              cursor: not-allowed;
              background-color: #ddd;
              color: #666;
            }
          }

          //
        }
      }
    }
  }
}

.tooltips_text {
  font-size: 14px;
  line-height: 1.7;
}

.create_error {
  width: 220px;
  height: 230px;
  background-color: #fff;
  border-radius: 4px;
  padding: 0 10px;
  padding-top: 28px;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;

  .error_icon {
    display: block;
    width: 35px;
    margin: 0 auto;
  }

  .error_text {
    color: #ccc;
    line-height: 44px;
  }

  .error_btn {
    display: inline-block;
    cursor: pointer;
    color: #ffab46;
    padding-top: 15px;
  }
}

.defeat_popup {
  //width: 600px;
  width: calc(100vw - 40px);
  box-sizing: border-box;
  padding: 0 30px 36px;
  background-color: #fff;
  border-radius: 10px;

  .popup_title {
    font-size: 16px;
    font-weight: bold;
    line-height: 76px;
    text-align: center;
    color: #000;
  }

  .popup_content {
    padding-bottom: 10px;

    .content_items{
      width: 100%;
      padding-bottom: 18px;
      font-size: 13px;
      line-height: 25px;
      .item_question{
        color: #000;
      }

      .item_answer {
        width: 100%;
        white-space: wrap;
        color: #999;
      }
    }
  }

  .close_btn {
    width: 240px;
    height: 50px;
    border: none;
    border-radius: 5px;
    background-color: #5865f2;
    color: #fff;
    font-size: 15px;
    display: block;
    margin: 0 auto;
  }
}

.msg-item-content {
  font-size: 13px;
  line-height: 20px;
  padding-top: 5px;

  &.detail_loading {
    .remove_icon {
      // display: none;
      position: absolute;
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("../img/update_close.png");
      background-color: rgba(100, 100, 100, 0.6);
      cursor: pointer;
      border-radius: 3px;
    }

    .loading_text {
      padding-left: 12px;
      color: #f0b132;
    }
  }
}

.creating_progress {
  margin-top: 15px;
  display: flex;
  align-items: center;
  width: 360px;

  .progress_bar {
    flex-grow: 1;
    height: 10px;
    border-radius: 5px;
    background-color: #dbefe4;
    margin-right: 6px;

    .progress_line {
      height: 100%;
      background-color: #f0b132;
      border-radius: 5px;
      transition: width 0.3s linear;
    }
  }

  .progress_percent {
    font-size: 12px;
    line-height: 1;
    color: #f0b132;
    white-space: nowrap;
  }
}

.msg_img_wrap {
  max-width: 400px;
  position: relative;
  overflow: hidden;
  display: inline-block;
  // border-radius:5px;
  &:hover {
    .img_footer {
      bottom: 0;
    }
  }

  .msg_img_ele {
    display: block;
    width: 100%;
    cursor: pointer;
  }

  .img_footer {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: -40px;
    height: 40px;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: space-around;
    transition: bottom 0.3s;

    .footer_item {
      cursor: pointer;

      .footer_icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-right: 5px;
        background-size: 100% 100%;

        &.download {
          background-image: url("../img/download.png");
        }

        &.preview {
          background-image: url("../img/preview_img.png");
        }

        &.delete {
          background-image: url("../img/remove.png");
        }
      }

      span {
        vertical-align: middle;
        display: inline-block;
        font-size: 14px;
        color: #fff;
      }
    }
  }
  .look_img {
    //display: none;
    //opacity: 0;
    cursor: pointer;
    width: 75px;
    height: 28px;
    position: absolute;
    top: 10px;
    right: 10px;
    border: rgba(88, 101, 242, 0.8) solid 2px;
    background-color: rgba(88, 101, 242, 0.533);
    border-radius: 6px;
    color: white;
    font-size: 12px;
    box-sizing: border-box;
    line-height: 24px;
    text-align: center;
  }
}

.more_list {
  .operate_item {
    height: 28px;
    font-size: 14px;
    color: #949ba4;

    img {
      width: 20px;
      height: 20px;
      margin-top: -2px;
      margin-right: 4px;

      &.share {
        width: 14px;
        height: 14px;
        margin-left: 3px;
        margin-right: 6px;
      }
    }
  }
}
</style>